import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose, Type } from 'class-transformer';

export class CAN2Status extends AdditionalInfoImpl {

  @Expose({ name: 'busstop_name' })
  busStopName: string;

  @Expose({ name: 'stop_date' })
  @Type(() => Date)
  stopDate: Date;

  @Expose({ name: 'left_date' })
  @Type(() => Date)
  leftDate: Date;

  @Expose({ name: 'aircond_on_date' })
  @Type(() => Date)
  acOnDate: Date;

  @Expose({ name: 'aircond_off_date' })
  @Type(() => Date)
  acOffDate: Date;

  @Expose({ name: 'heating_on_date' })
  @Type(() => Date)
  heatingOnDate: Date;

  @Expose({ name: 'heating_off_date' })
  @Type(() => Date)
  heatingOffDate: Date;

  @Expose({ name: 'temp_inside' })
  tempInside: number;

  @Expose({ name: 'pnz_on' })
  requestStop: boolean;

  @Expose({ name: 'last_busstop_distance' })
  lastBusStopDistance: number;

  @Expose({ name: 'latitude' })
  latitude: number;

  @Expose({ name: 'longitude' })
  longitude: number;

  @Expose({ name: 'int_lights_on' })
  internalLightsOn: boolean;

  @Expose({ name: 'engine_on' })
  engineOn: boolean;

  @Expose({ name: 'doors' })
  doors: boolean;

  @Expose({ name: 'neutral_date' })
  @Type(() => Date)
  neutralGearDate: Date;

  @Expose({ name: 'eng_rpm_ex' })
  engineRpmExceeded: boolean;

  @Expose({ name: 'fuel_level' })
  fuelLevel: number;

  @Expose({ name: 'fuel_used' })
  fuelUsed: number;

  @Expose({ name: 'driver_mileage' })
  driverMileage: number;

  @Expose({ name: 'reverse_on' })
  reverseOn: boolean;

  @Expose({ name: 'ignition' })
  ignition: boolean;

  @Expose({ name: 'tacho_speed' })
  tachoSpeed: number;

  @Expose({ name: 'line' })
  line: string;

  @Expose({ name: 'team' })
  team: string;

  @Expose({ name: 'mileage' })
  mileage: number;

  @Expose({ name: 'busstop_timetable' })
  busStopTimetable: string;

  @Expose({ name: 'destination_bus_stop' })
  destinationBusStop: string;

  @Expose({ name: 'destination_distance' })
  distanceToDestination: number;

  @Expose({ name: 'direction' })
  direction: string;

  @Expose({ name: 'events_date' })
  @Type(() => Date)
  statusDate: Date;

  @Expose({ name: 'fuel_consumption' })
  fuelConsumption: number;
}
